// Who qualifies for the Grand Final, one rule for every view and export (16 Oct 2026, from the Tbilisi Live, where three
// players finished in a small battle's top ten without answering a question). A player qualifies when their final place is
// within the battle's top N (QualifyConfig.top) AND they scored at least one point: a final score above 0, the score every
// view shows (scoreWithBonus: rarity points in, voided questions out). The rule as players read it stays "Top 10 qualify";
// the condition is said only to a player it leaves out.
import type { QualifyConfig } from './types';

/** Whether a final place and score qualify under the battle's rule. Nothing qualifies without a rule, a place or a score. */
export function qualifies(q: Pick<QualifyConfig, 'top'> | undefined, rank: number | undefined, score: number | undefined): boolean {
  return Boolean(q && typeof rank === 'number' && rank >= 1 && rank <= q.top && typeof score === 'number' && score > 0);
}
